/**
 * MG Cycle Advisor — Asesoría ciclos Línea Avanzada
 */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-mg-cycle]');
  if (!roots.length) return;

  function formatCLP(amount) {
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(amount);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function criticalOosCount(cycle) {
    return (cycle.components || []).filter(function (c) {
      return c.out_of_stock && !c.optional;
    }).length;
  }

  function optionalOosCount(cycle) {
    return (cycle.components || []).filter(function (c) {
      return c.out_of_stock && c.optional;
    }).length;
  }

  function scoreCycle(cycle, answers) {
    var s = cycle.score || 50;
    if (cycle.goals.indexOf(answers.goal) >= 0) s += 40;
    if (cycle.experience.indexOf(answers.experience) >= 0) s += 25;
    if (cycle.levels.indexOf(answers.level) >= 0) s += 15;
    if (cycle.budgets.indexOf(answers.budget) >= 0) s += 15;
    if (answers.experience === 'none' && cycle.goals.indexOf('sarms') >= 0) s += 10;
    if (answers.experience === 'experienced' && cycle.goals.indexOf('definition') >= 0) s += 8;
    s -= criticalOosCount(cycle) * 80;
    s -= optionalOosCount(cycle) * 12;
    return s;
  }

  function isCycleBlocked(cycle, live) {
    if (criticalOosCount(cycle) > 0) return true;
    if (live && live.available === false) return true;
    return false;
  }

  function waLink(phone, text) {
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
  }

  function buildQuiz(root, data) {
    var state = { step: 0, answers: {}, steps: ['goal', 'experience', 'level', 'budget'] };
    var quizEl = root.querySelector('.mg-cycle__quiz');
    var resultsEl = root.querySelector('.mg-cycle__results');
    var progressBar = root.querySelector('.mg-cycle__progress-bar');
    var stepLabel = root.querySelector('.mg-cycle__step-label');
    var questionEl = root.querySelector('.mg-cycle__question');
    var optionsEl = root.querySelector('.mg-cycle__options');
    var btnBack = root.querySelector('.mg-cycle__btn--back');
    var btnNext = root.querySelector('.mg-cycle__btn--next');
    var resultCards = root.querySelector('.mg-cycle__result-cards');
    var resultSubtitle = root.querySelector('.mg-cycle__result-subtitle');
    var btnRestart = root.querySelector('.mg-cycle__restart');

    var stepConfig = {
      goal: { key: 'goals', q: '¿Cuál es tu propósito principal?' },
      experience: { key: 'experience', q: '¿Experiencia con compuestos?' },
      level: { key: 'levels', q: '¿Nivel de entrenamiento en el gym?' },
      budget: { key: 'budgets', q: '¿Presupuesto aproximado para el ciclo?' }
    };

    function renderStep() {
      var stepKey = state.steps[state.step];
      var cfg = stepConfig[stepKey];
      var items = data[cfg.key];

      progressBar.style.width = ((state.step + 1) / state.steps.length * 100) + '%';
      stepLabel.textContent = 'Paso ' + (state.step + 1) + ' de ' + state.steps.length;
      questionEl.textContent = cfg.q;
      optionsEl.innerHTML = '';

      items.forEach(function (item) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mg-cycle__option' + (state.answers[stepKey] === item.id ? ' is-selected' : '');
        btn.innerHTML =
          '<span class="mg-cycle__option-icon">' + (item.icon || '▸') + '</span>' +
          '<span class="mg-cycle__option-text"><strong>' + item.label + '</strong><span>' + item.desc + '</span></span>';
        btn.addEventListener('click', function () {
          state.answers[stepKey] = item.id;
          renderStep();
          btnNext.disabled = false;
        });
        optionsEl.appendChild(btn);
      });

      btnBack.disabled = state.step === 0;
      btnNext.textContent = state.step === state.steps.length - 1 ? 'Ver mi ciclo' : 'Siguiente';
      btnNext.disabled = !state.answers[stepKey];
    }

    function showResults() {
      quizEl.classList.add('is-hidden');
      resultsEl.classList.add('is-visible');
      resultCards.innerHTML = '<div class="mg-cycle__loading">Analizando tu perfil...</div>';

      var goalLabel = (data.goals.find(function (g) { return g.id === state.answers.goal; }) || {}).label || '';
      resultSubtitle.textContent = 'Propósito: ' + goalLabel + ' · Te mostramos hasta 3 ciclos acordes';

      var ranked = data.cycles
        .map(function (c) { return { cycle: c, score: scoreCycle(c, state.answers) }; })
        .sort(function (a, b) { return b.score - a.score; });

      Promise.all(ranked.map(function (r) {
        return fetchProduct(r.cycle.handle).then(function (live) {
          return { rank: r, live: live, blocked: isCycleBlocked(r.cycle, live) };
        });
      })).then(function (items) {
        resultCards.innerHTML = '';
        var shown = 0;
        var pool = items.filter(function (item) { return !item.blocked; }).slice(0, 3);

        if (!pool.length) {
          resultCards.innerHTML =
            '<p class="mg-cycle__empty">No hay ciclos con stock completo ahora. ' +
            '<a href="' + waLink(data.whatsapp, 'Necesito asesoría de ciclos Línea Avanzada con stock disponible') + '">Escríbenos por WhatsApp</a> y armamos tu pack.</p>';
          return;
        }

        pool.forEach(function (item) {
          var c = item.rank.cycle;
          var p = item.live;
          var price = p ? p.price / 100 : c.price_bundle;
          var compare = c.price_sum;
          var avail = p ? p.available : true;
          var img = p && (p.featured_image || (p.images && p.images[0])) || '';
          shown++;

          var compHtml = c.components.map(function (comp) {
            var stock = '';
            if (comp.out_of_stock) {
              stock = comp.optional
                ? ' <small class="mg-cycle__oos">(opcional, sin stock)</small>'
                : ' <small class="mg-cycle__oos">(sin stock)</small>';
            }
            return '<li>' + comp.role + ': ' + comp.title + stock + '</li>';
          }).join('');

          var waText = 'Hola, quiero asesoría sobre el ciclo: ' + c.title + '. Mi meta es ' + goalLabel + '.';
          var card = document.createElement('article');
          card.className = 'mg-cycle__result-card';
          card.innerHTML =
            '<div class="mg-cycle__result-rank">' + shown + '</div>' +
            (img ? '<img class="mg-cycle__result-img" src="' + img + '" alt="" loading="lazy">' : '') +
            '<div class="mg-cycle__result-body">' +
              '<h4>' + c.title + '</h4>' +
              '<p class="mg-cycle__result-short">' + c.short + '</p>' +
              '<p class="mg-cycle__result-reason">' + c.reason + '</p>' +
              '<ul class="mg-cycle__result-components">' + compHtml + '</ul>' +
              '<p class="mg-cycle__result-duration">Duración sugerida: <strong>' + c.duration + '</strong></p>' +
              (c.notes ? '<p class="mg-cycle__result-notes">' + c.notes + '</p>' : '') +
              '<div class="mg-cycle__result-pricing">' +
                '<span class="mg-cycle__price-compare">' + formatCLP(compare) + '</span>' +
                '<span class="mg-cycle__price-bundle">' + formatCLP(price) + '</span>' +
                '<span class="mg-cycle__price-save">Ahorras ' + formatCLP(compare - price) + '</span>' +
              '</div>' +
              '<div class="mg-cycle__result-actions">' +
                (p ? '<a href="/products/' + p.handle + '" class="mg-cycle__btn-buy">' + (avail ? 'Ver pack →' : 'Consultar stock') + '</a>' : '') +
                '<a href="' + waLink(data.whatsapp, waText) + '" class="mg-cycle__btn-wa" target="_blank" rel="noopener">Asesoría WhatsApp</a>' +
              '</div>' +
            '</div>';
          resultCards.appendChild(card);
        });

        if (shown === 0) {
          resultCards.innerHTML =
            '<p class="mg-cycle__empty">No hay ciclos disponibles ahora. ' +
            '<a href="' + waLink(data.whatsapp, 'Necesito asesoría de ciclos Línea Avanzada') + '">Escríbenos por WhatsApp</a>.</p>';
        }

        try {
          localStorage.setItem('mg-cycle-result', JSON.stringify(state.answers));
        } catch (e) {}
      });
    }

    btnBack.addEventListener('click', function () {
      if (state.step > 0) { state.step--; renderStep(); }
    });

    btnNext.addEventListener('click', function () {
      if (state.step < state.steps.length - 1) {
        state.step++;
        renderStep();
      } else {
        showResults();
      }
    });

    btnRestart.addEventListener('click', function () {
      state = { step: 0, answers: {}, steps: ['goal', 'experience', 'level', 'budget'] };
      resultsEl.classList.remove('is-visible');
      quizEl.classList.remove('is-hidden');
      renderStep();
    });

    renderStep();
  }

  roots.forEach(function (root) {
    var dataUrl = root.getAttribute('data-mg-cycle-url');
    if (!dataUrl) return;

    fetch(dataUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.json();
      })
      .then(function (data) { buildQuiz(root, data); })
      .catch(function () {
        root.querySelector('.mg-cycle__options').innerHTML =
          '<p class="mg-cycle__error">Error al cargar el asesor. <a href="https://wa.me/' + (root.getAttribute('data-mg-cycle-wa') || '19567414430') + '">Contáctanos</a>.</p>';
      });
  });
})();